import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-sumi py-20 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Card */}
        <div className="bg-sumi/80 rounded-lg p-12 relative">
          {/* Decorative Elements */}
          <div className="absolute -top-4 -left-4 w-24 h-24 bg-indigo rotate-12 rounded-sm"></div>
          <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-indigo -rotate-12 rounded-sm"></div>

          <div className="relative grid grid-cols-1 md:grid-cols-4 gap-12">
            {/* Left Block - Logo & Mission */}
            <div className="space-y-6">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src="https://public.readdy.ai/ai/img_res/79998c31-8dcb-4257-9950-200bb8348595.png"
                  alt="Institute Logo"
                  className="h-12 w-12 object-contain"
                />
              </div>
              <h3 className="font-serif text-base text-white leading-relaxed">
                日本音楽藝術表現研究所
              </h3>
              <p className="font-sans text-xs text-white/80 leading-relaxed">
                Produced by Shogo Yoshii
              </p>
              <p className="font-serif text-sm text-white/70 leading-loose">
                島国の感性を基盤に、日本音楽の身体知を分析・再構築する研究機関。
              </p>
            </div>

            {/* Navigation Columns */}
            <div>
              <h4 className="font-sans text-xs font-semibold text-white/90 mb-4 tracking-widest uppercase">
                Research
              </h4>
              <nav className="space-y-3">
                <button
                  onClick={() => scrollToSection('philosophy')}
                  className="block font-sans text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Philosophy
                </button>
                <Link
                  to="/philosophy"
                  className="block font-sans text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Methodology
                </Link>
              </nav>
            </div>

            <div>
              <h4 className="font-sans text-xs font-semibold text-white/90 mb-4 tracking-widest uppercase">
                Solutions
              </h4>
              <nav className="space-y-3">
                <button
                  onClick={() => scrollToSection('ensemble')}
                  className="block font-sans text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Ensemble I
                </button>
                <button
                  onClick={() => scrollToSection('ensemble')}
                  className="block font-sans text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Ensemble Ro
                </button>
                <button
                  onClick={() => scrollToSection('ensemble')}
                  className="block font-sans text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Ensemble Ha
                </button>
                <button
                  onClick={() => scrollToSection('ensemble')}
                  className="block font-sans text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Ensemble Ni
                </button>
              </nav>
            </div>

            <div>
              <h4 className="font-sans text-xs font-semibold text-white/90 mb-4 tracking-widest uppercase">
                About
              </h4>
              <nav className="space-y-3">
                <button
                  onClick={() => scrollToSection('credentials')}
                  className="block font-sans text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Credentials
                </button>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="block font-sans text-sm text-white/70 hover:text-indigo transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contact
                </button>
              </nav>

              <div className="mt-8">
                <h4 className="font-sans text-xs font-semibold text-white/90 mb-4 tracking-widest uppercase">
                  Follow
                </h4>
                <div className="flex flex-col gap-3">
                  <a
                    href="https://www.instagram.com/shogo_yoshii_/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 flex items-center justify-center text-white/70 hover:text-indigo transition-colors cursor-pointer"
                    aria-label="Instagram"
                  >
                    <i className="ri-instagram-line text-xl"></i>
                  </a>
                  <a
                    href="#"
                    className="w-8 h-8 flex items-center justify-center text-white/70 hover:text-indigo transition-colors cursor-pointer"
                    aria-label="YouTube"
                  >
                    <i className="ri-youtube-line text-xl"></i>
                  </a>
                  <a
                    href="#"
                    className="w-8 h-8 flex items-center justify-center text-white/70 hover:text-indigo transition-colors cursor-pointer"
                    aria-label="LinkedIn"
                  >
                    <i className="ri-linkedin-line text-xl"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="mt-12 flex flex-col md:flex-row justify-between items-center gap-4 text-white/50 text-xs font-sans">
          <p>© 2025 Institute of Japanese Musical Art Expression. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap">
              Privacy Policy
            </a>
            <span>|</span>
            <a href="#" className="hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}